import { Divider, Group, Skeleton } from "@mantine/core";

function LoadingWorkingHours() {
  return (
    <>
      <Group justify="space-between">
        <Skeleton w="30%" height={20} />
        <Skeleton w="10%" height={20} />
      </Group>
      <Divider />
      <Group justify="space-between">
        <Skeleton w="30%" height={20} />
        <Skeleton w="10%" height={20} />
      </Group>
      <Divider />
      <Group justify="space-between">
        <Skeleton w="30%" height={20} />
        <Skeleton w="10%" height={20} />
      </Group>
      <Divider />
      <Group justify="space-between">
        <Skeleton w="30%" height={20} />
        <Skeleton w="10%" height={20} />
      </Group>
      <Divider />
      <Group justify="space-between">
        <Skeleton w="30%" height={20} />
        <Skeleton w="10%" height={20} />
      </Group>
      <Divider />
      <Group justify="space-between">
        <Skeleton w="30%" height={20} />
        <Skeleton w="10%" height={20} />
      </Group>
      <Divider />
      <Group justify="space-between">
        <Skeleton w="30%" height={20} />
        <Skeleton w="10%" height={20} />
      </Group>
    </>
  );
}

export default LoadingWorkingHours;
